import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "@lightspeed/flame/Card";
import { Input } from "@lightspeed/flame/Input";
import { Button } from "@lightspeed/flame/Button";
import { setFiltered } from "../../redux/actions/databaseActions";
import * as databaseActions from "../../redux/actions/databaseActions";
import { createSyncLogId, superSyncLog } from "../../utils/superSyncLog";

const LocationTopBar = ({ setExtended, extended }) => {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userState);
  const ui = useSelector((state) => state.ui);
  const database = useSelector((state) => state.database);

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false); // 👈 indikator

  const handleClick = () => {
    setExtended((oldState) => !oldState);
  };

  const handleClick2 = () => {
    setLoading(true);
    const { id, type } = database.currentCompany;
    const userId = userState.user.user_id;
    const syncId = createSyncLogId(type, id);

    superSyncLog(syncId, "SYNC_CLICK", {
      userId,
      companyId: id,
      companyType: type,
      table: ui.table,
      areaId: database.currentShop?.area_id,
      shopId: database.currentShop?.shop_id,
      currentCounts: {
        payments: database.currentShop?.payments?.length || 0,
        categories: database.currentShop?.categories?.length || 0,
        other: database.currentShop?.other?.length || 0,
        taxes: database.currentShop?.taxes?.length || 0,
      },
    });

    if (type === "RETAIL") {
      dispatch(databaseActions.getRetailRSYNC(id, userId, syncId));
    } else if (type === "RETAILX") {
      dispatch(databaseActions.getRetailXRSYNC(id, userId, syncId));
    } else if (type === "RESTO") {
      dispatch(databaseActions.getRestoLRSYNC(id, userId, syncId));
    } else if (type === "RESTOK") {
      dispatch(databaseActions.getRestoKRSYNC(id, userId, syncId));
    }

    setTimeout(() => {
      superSyncLog(syncId, "SYNC_BUTTON_LOADING_TIMEOUT", { timeoutMs: 30000 });
      setLoading(false);
    }, 30000);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    dispatch(setFiltered(value));
  }, [value, dispatch]);

  return (
    <Card
      top="true"
      className={`location-top-bar ${
        ui.theme === "flame" ? "" : "location-top-bar-dark"
      }`}
    >
      <div className="flex" />

<button
  type="submit"
  onClick={handleClick2}
  disabled={loading}
  title="Sync from Lightspeed"
  style={{
    backgroundColor: loading ? "#218838" : "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 12px",
    fontWeight: "bold",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    opacity: loading ? 0.6 : 1,
  }}
>
  {loading ? "🔄 Syncing..." : "SYNC"}
</button>

      {database.currentCompany.shops.length > 7 && (
        <Button size="small" type="submit" fill="true" onClick={handleClick}>
          {extended ? "Collapse Locations" : "Extend Locations"}
        </Button>
      )}

      <div className="input-wrapper">
        <Input
          className="input-custom-bg"
          value={value}
          onChange={handleChange}
          type="text"
          size="small"
          placeholder="Search by Location"
        />
      </div>
    </Card>
  );
};

export default LocationTopBar;
